import { createSelector } from 'reselect'
import { findPostPurchaseCheckout } from 'lib/checkout/checkoutUtils'
import { isSpoofed } from 'selectors/isSpoofed'
import isPassportCardInsurancePostPurchaseEnabled from 'selectors/isPassportCardInsurancePostPurchaseEnabled'

/**
 * Public post-purchase entry point: an insurance-only checkout (`mode: 'insurance'`) on an
 * existing order PassportCard can cover. The cart carries no trip items in that mode, so
 * the decision is made on the order rather than on the cart. Spoof mode keeps offering
 * PassportCard through the spoofed comparison section (isPassportCardInsuranceSupportedSpoofed)
 * and is excluded here so each flow has a single product decision.
 */
const isPassportCardInsuranceSupportedPostPurchase = createSelector(
  (state: App.State) => findPostPurchaseCheckout(state.checkout.cart.mode),
  (state: App.State) => isSpoofed(state),
  (state: App.State) => isPassportCardInsurancePostPurchaseEnabled(state),
  (postPurchase, spoofed, isEnabledForExistingOrder): boolean => {
    return postPurchase === 'insurance' && !spoofed && isEnabledForExistingOrder
  },
)

export default isPassportCardInsuranceSupportedPostPurchase
